import { Component } from "react"
import PropTypes from "prop-types"
import Tippy from "shared/lib/tippy"

import QuestionIcon from "shared/components/icons/question_icon"

import "./tooltip.scss"

class Tooltip extends Component {
  getTooltipHtml = () => {
    return <div styleName="tooltip-content">{this.props.content}</div>
  }

  render() {
    return (
      <Tippy
        duration={200}
        delay={50}
        arrow={true}
        maxWidth={"250px"}
        html={this.getTooltipHtml()}
        placement={"bottom-end"}
      >
        <QuestionIcon iconClasses={this.props.isWhite ? "white" : ""} />
      </Tippy>
    )
  }
}

Tooltip.propTypes = {
  content: PropTypes.string,
  isWhite: PropTypes.bool,
}

export default Tooltip
